import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Pipe({
    name: 'formGroup',
    standalone: true
})
export class FormGroupPipe implements PipeTransform {
    transform(value: AbstractControl): FormGroup {
        if (value instanceof FormGroup) {
            return value satisfies FormGroup;
        } else {
            throw new Error('Control is not a form group.');
        }
    }
}
